module.exports = __webpack_public_path__ + "static/media/img_logo_galicia.42509118.png";